import Image from 'next/image'
import { InvestorBigCardType, InvestorCardType } from '@interfaces/aboutUs'
import { useElementVisible } from '@hooks/useElementVisible'
import styles from './InvestorSection.module.scss'

export const InvestorBigCard = ({ data }: InvestorBigCardType) => {
  const bigCardSection = useElementVisible({ threshold: 0.2 })
  return (
    <div
      ref={bigCardSection.ref}
      className={`${styles.investorBigCard} ${bigCardSection.isVisible ? styles.popOutAnimation : ''}`}>
      <Image src={data.investorLogoUrl} alt="Investor Image" width={200} height={60} />
      <p className={styles.investorContent}>{data.investorContent}</p>
      <div className={styles.investorNameContainer}>
        <p className={styles.investorName}>{data.investorName}</p>
        <p className={styles.investorTitle}>{data.investorTitle}</p>
      </div>
    </div>
  )
}

export const InvestorCard = ({ data }: InvestorCardType) => {
  const smallCardSection = useElementVisible({ threshold: 0.2 })
  return (
    <div
      ref={smallCardSection.ref}
      className={`${styles.investorCard} ${smallCardSection.isVisible ? styles.popOutAnimation : ''}`}>
      <Image src={data.investorLogoUrl} alt="Investor Image" width={180} height={56} />
    </div>
  )
}
